import { useEffect, useRef } from 'react';
import api from '@/lib/api';

const INTERVAL_MS = 60000;
let lastBeatAt = 0; // evita latidos duplicados (doble montaje / visibilitychange inmediato)

// Latido de presencia: marca al usuario "en línea" y acumula su permanencia (una sesión = racha de latidos)
export const usePresenceHeartbeat = (pathname) => {
  const pathRef = useRef(pathname);
  pathRef.current = pathname;

  useEffect(() => {
    let stopped = false;
    const beat = () => {
      if (stopped || document.visibilityState === 'hidden' || Date.now() - lastBeatAt < 5000) return;
      lastBeatAt = Date.now();
      api.post('/presence/heartbeat', { path: pathRef.current }, { silent: true, timeout: 5000 }).catch(() => {});
    };
    beat();
    const id = setInterval(beat, INTERVAL_MS);
    document.addEventListener('visibilitychange', beat);
    return () => { stopped = true; clearInterval(id); document.removeEventListener('visibilitychange', beat); };
  }, []);
};

export const PresenceHeartbeat = ({ pathname }) => { usePresenceHeartbeat(pathname); return null; };

export default PresenceHeartbeat;
